import React, { useState, useEffect, useCallback } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './components/Home';
import Quiz from './components/Quiz';
import Result from './components/Result';
import MoreGame from './components/AdsBanner';
import PlayerSection from './components/PlayerSection';
import JsonLd from './JsonLdMeta'; // Adjust path as necessary
import { auth, db } from './firebase'; // Adjust path as necessary
import { doc, getDoc } from 'firebase/firestore';

function App() {
  const [user, setUser] = useState(null);
  const [playerData, setPlayerData] = useState(null);
  const [seoData, setSeoData] = useState(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setUser(user);
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const fetchSeoData = async () => {
      try {
        const docRef = doc(db, 'metaDetails', 'bUlS3lrsc77fYJrCRmBG'); // Replace with your document ID
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setSeoData(docSnap.data());
        } else {
          console.log('No such document!');
        }
      } catch (error) {
        console.error('Error fetching SEO data:', error);
      }
    };

    fetchSeoData();
  }, []);

  const handlePlayerData = useCallback((data) => {
    setPlayerData(data);
  }, []);

  const getSeoData = () => {
    if (seoData) {
      return {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": seoData.title,
        "description": seoData.description,
        "url": window.location.href,
        "sameAs": [
          "https://twitter.com/Eduplayzone",
          "https://www.facebook.com/Eduplayzone",
        ],
        "potentialAction": {
          "@type": "SearchAction",
          "target": {
            "@type": "EntryPoint",
            "urlTemplate": "https://eduplayzone.in/quiz-zone/search?query={search_term_string}"
          },
          "query-input": "required name=search_term_string"
        }
      };
    }
    return null;
  };

  return (
    <Router basename="/quiz-zone">
      <div className="App">
        <JsonLd data={getSeoData()} />
        {!playerData && <PlayerSection onPlayerData={handlePlayerData} />}
        {playerData && (
          <Routes>
            <Route path="/" element={<Home playerData={playerData} setPlayerData={setPlayerData} />} />
            <Route path="/quiz" element={<Quiz playerData={playerData} />} />
            <Route path="/result" element={<Result playerData={playerData} />} />
            <Route path="/moregame" element={<MoreGame playerData={playerData} />} />
          </Routes>
        )}
      </div>
    </Router>
  );
}

export default App;
